import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
    this.updateTabTitle();
    this._mutationObserver = new MutationObserver(() => this.updateTabTitle());
    this._mutationObserver.observe(this, { attributes: true, attributeFilter: ['data-filtered-count', 'data-search-terms'] });
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
    if (this._mutationObserver) this._mutationObserver.disconnect();
  }

  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;
    this.#animateLayoutChange(target.value);
  }

  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;
    if (!grid) return;
    await startViewTransition(() => this.#setLayout(value), ['product-grid']);
    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };

  updateTabTitle() {
    const fc = this.getAttribute('data-filtered-count');
    const q = this.getAttribute('data-search-terms') || '';
    const count = Number(fc);
    if (!Number.isNaN(count)) {
      const qDisplay = q ? " '" + q + "'" : '';
      const title = "Search: " + count + " result" + (count === 1 ? "" : "s") + " found for" + qDisplay;
      document.title = title;
      const og = document.querySelector("meta[property='og:title']");
      if (og) og.setAttribute("content", title);
      const tw = document.querySelector("meta[name='twitter:title']");
      if (tw) tw.setAttribute("content", title);
    }
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
